export default {
    "clipboard": {
        "success": "{data} copié dans le presse-papiers",
        "error": "Erreur du presse-papiers"
    }
};
